import { useState } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import DefaultTraceIndicatorForm from "../Forms/DefaultTraceIndicatorForm.js";
import Loader from "../Loader.js";
import { AnalysisAPI } from "../../api/index.js";
import { useMutation } from "@tanstack/react-query";
import LoggingAPI from "../../api/logging/index.js";
import { usePermissions } from "../../hooks/usePermissions";

export const EditTraceIndicatorModal = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultFormData,
  ...props
}) => {
  const { currentUser } = usePermissions();
  const [submitting, setSubmitting] = useState(false);

  const updateTraceIndicator = useMutation({
    mutationFn: AnalysisAPI.TraceIndicators.update,
    onMutate: () => setSubmitting(true),
    onSuccess: (_, variables) => {
      LoggingAPI.createLog({
        case_id: defaultFormData.case_id,
        user_id: currentUser.user_id,
        message: `Updated trace indicator.`,
        event: "trace_indicator:update",
        object_type: "trace_indicator",
        object_uuid: defaultFormData.uuid,
      });
      onSubmit?.(defaultFormData, variables);
      setSubmitting(false);
    },
  });

  return (
    <Modal open={show} onClose={onClose} style={{ width: 620 }}>
      <Modal.Title style={{ marginBottom: 10 }}>
        Edit Trace Indicator
      </Modal.Title>
      {!submitting && (
        <DefaultTraceIndicatorForm
          onSubmit={(data, diff) =>
            updateTraceIndicator.mutate({
              uuid: data.uuid,
              case_uuid: defaultFormData.case_uuid,
              ...diff,
            })
          }
          onCancel={onCancel}
          defaultFormData={defaultFormData}
          excludedFields={["evidence_uuid", "timeline_event_uuid"]}
          {...props}
        />
      )}
      {submitting && <Loader />}
    </Modal>
  );
};
